/**
 * @Description 商圈详情概览
 */

import { FC } from 'react';
// import cs from 'classnames';
import styles from './index.module.less';
import Evaluations from './Evaluations';
import Basic from './Basic';

const AreaOverview: FC<any> = ({
  overViewData,
  detail,
  mapIns,
  rangeMarkerRef,
  setIsOpenHeatMap,
  configSwitch,
  isShare,
  shareParams = {},
  isSemirModel = false,
}) => {

  return (
    <div className={styles.mainBacCon}>
      {/* 评分 */}
      <Evaluations
        overView={overViewData}
        picList={detail?.picList || []}
        configSwitch={configSwitch}
        shareParams={shareParams}
        isSemirModel={isSemirModel}
      />
      {/* 明细 */}
      <Basic
        detail={detail}
        overView={overViewData}
        mapIns={mapIns}
        rangeMarkerRef={rangeMarkerRef}
        setIsOpenHeatMap={setIsOpenHeatMap}
        isShare={isShare}
        shareParams={shareParams}
      />
    </div>
  );
};

export default AreaOverview;
